<template>
  <transition name="slide-up">
    <div class="app-flow" :class="[`mq-${$mq}`]" v-if="visible">
      <div class="inner" :class="[`mq-${$mq}`]">
        <div class="corner-radius-blur topics"></div>
        <button class="close" @click="close()" :class="[`mq-${$mq}`]">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.6465 0.646692C10.8417 0.45143 11.1582 0.45143 11.3535 0.646692C11.5488 0.841954 11.5488 1.15846 11.3535 1.35372L6.70703 6.00021L11.3535 10.6467L11.418 10.7248C11.5461 10.9189 11.5244 11.1829 11.3535 11.3537C11.1826 11.5246 10.9187 11.5463 10.7246 11.4182L10.6465 11.3537L5.99999 6.70724L1.35351 11.3537C1.15825 11.549 0.84174 11.549 0.646478 11.3537C0.451216 11.1585 0.451216 10.842 0.646478 10.6467L5.29296 6.00021L0.646478 1.35372L0.582025 1.2756C0.453861 1.08152 0.475614 0.817555 0.646478 0.646692C0.817342 0.475828 1.08131 0.454074 1.27538 0.582239L1.35351 0.646692L5.99999 5.29318L10.6465 0.646692Z" />
          </svg>
        </button>

        <div class="invite-wrap">
          <div class="invite-header">
            <div class="mark">
              <svg class="mark" width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.8155 0.333496H25.2108L26 27.543L22.3455 28.528C19.0387 21.6494 15.9202 17.0187 12.0139 12.5849C14.2398 17.1322 16.1344 21.5113 17.9382 26.9294L14.7827 29.0821C12.9082 27.1982 11.3929 25.6079 10.0191 24.1662C9.32427 23.437 8.66566 22.7459 8.01512 22.0739C8.35032 23.228 8.64076 24.4982 8.89176 25.9526L9.11995 27.2747L6.17839 29.3335L1.08112 27.7603L2.16583 23.8458L4.67471 24.6202C3.75914 20.7111 2.39269 18.4625 0 14.55L2.80964 11.8344C6.16062 14.5846 8.47279 16.8392 10.8231 19.2666C8.89802 14.89 6.71962 10.7221 4.00901 5.5359C3.5973 4.74818 3.17331 3.93697 2.73606 3.09797L5.71753 0.595527C12.5625 7.05909 17.298 11.8688 21.7241 19.129L20.8155 0.333496Z" />
              </svg>
            </div>

            <!-- <p>Enter your invite code below to explore what's coming next with the new Nourish.</p> -->
            <h2>Did a friend invite you?</h2>
          </div>

          <div class="invite-stack">
            <div class="profile-wrapper">
              <div v-if="status === 'searching'" class="message">
                <Loading/>
              </div>

              <div v-if="status === 'error'" class="message error">
                <span>Uh oh, we couldn't find that handle. Double-check that it matches exactly what's in your invite.</span>
              </div>

              <div v-if="status === 'found'" class="profile" @click="go()">
                <div class="content">
                  <img :src="profile.avatar"/>
                  <span>{{ profile.name }}</span>
                </div>

                <div class="profile-arrow">
                  <span>Start</span>
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.71604 11.6564C9.52077 11.8515 9.20421 11.8516 9.00901 11.6564C8.81414 11.4612 8.81405 11.1445 9.00901 10.9494L13.4592 6.49916L1.33323 6.49916L1.23167 6.48939C1.00406 6.44259 0.833231 6.24062 0.833231 5.99916C0.83356 5.75802 1.00429 5.55667 1.23167 5.5099L1.33323 5.49916L13.4592 5.49916L9.00901 1.04994L8.94554 0.970836C8.81778 0.776914 8.83856 0.513646 9.00901 0.342906C9.1798 0.172292 9.44393 0.150538 9.63792 0.278453L9.71604 0.342906L15.0198 5.64564C15.2149 5.84078 15.2146 6.15738 15.0198 6.35267L9.71604 11.6564Z" fill="white"/>
                  </svg>
                </div>
              </div>

              <form @submit.prevent="checkHandle()">
                <input class="code-input" type="text" v-model="handle" placeholder="Enter your invite code...">
              </form>

              <button class="ghost login" @click="login()">Already have an account? Sign in</button>

            </div>

            <div class="invite-break">
              <span>or</span>
            </div>
            
            <div class="invite-social">
              <h4>Did you find us elsewhere?</h4>

              <div class="invite-options">
                <div class="invite-break spacer">
                  <span>App Store</span>
                </div>

                <div v-for="profile in options.invites_s" :key="profile.screen_name" class="profile" @click="start(profile.screen_name)">
                  <div class="content">
                    <img :src="profile.avatar"/>
                    <span>{{ profile.name }}</span>
                  </div>

                  <div class="profile-arrow">
                    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.71604 11.6564C9.52077 11.8515 9.20421 11.8516 9.00901 11.6564C8.81414 11.4612 8.81405 11.1445 9.00901 10.9494L13.4592 6.49916L1.33323 6.49916L1.23167 6.48939C1.00406 6.44259 0.833231 6.24062 0.833231 5.99916C0.83356 5.75802 1.00429 5.55667 1.23167 5.5099L1.33323 5.49916L13.4592 5.49916L9.00901 1.04994L8.94554 0.970836C8.81778 0.776914 8.83856 0.513646 9.00901 0.342906C9.1798 0.172292 9.44393 0.150538 9.63792 0.278453L9.71604 0.342906L15.0198 5.64564C15.2149 5.84078 15.2146 6.15738 15.0198 6.35267L9.71604 11.6564Z" fill="white"/>
                    </svg>
                  </div>
                </div>

                <div class="invite-break spacer">
                  <span>Social</span>
                </div>

                <div v-for="profile in options.invites_p" :key="profile.screen_name" class="profile" @click="start(profile.screen_name)">
                  <div class="content">
                    <img :src="profile.avatar"/>
                    <span>{{ profile.name }}</span>
                  </div>

                  <div class="profile-arrow">
                    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.71604 11.6564C9.52077 11.8515 9.20421 11.8516 9.00901 11.6564C8.81414 11.4612 8.81405 11.1445 9.00901 10.9494L13.4592 6.49916L1.33323 6.49916L1.23167 6.48939C1.00406 6.44259 0.833231 6.24062 0.833231 5.99916C0.83356 5.75802 1.00429 5.55667 1.23167 5.5099L1.33323 5.49916L13.4592 5.49916L9.00901 1.04994L8.94554 0.970836C8.81778 0.776914 8.83856 0.513646 9.00901 0.342906C9.1798 0.172292 9.44393 0.150538 9.63792 0.278453L9.71604 0.342906L15.0198 5.64564C15.2149 5.84078 15.2146 6.15738 15.0198 6.35267L9.71604 11.6564Z" fill="white"/>
                    </svg>
                  </div>
                </div>

                <div class="invite-break spacer">
                  <span>Who Knows</span>
                </div>

                <div class="profile" @click="start('nourish')">
                  <div class="content">
                    <div class="empty-image">
                      <svg width="29" height="46" viewBox="0 0 29 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.8 14.375C5.8 9.61328 9.69688 5.75 14.5 5.75C19.3031 5.75 23.2 9.61328 23.2 14.375C23.2 18.2113 20.6716 21.4637 17.1734 22.5867C14.5997 23.4133 11.6 25.7582 11.6 29.4688V31.625C11.6 33.2152 12.8959 34.5 14.5 34.5C16.1041 34.5 17.4 33.2152 17.4 31.625V29.4688C17.4 29.316 17.4544 29.1004 17.7172 28.8129C17.9891 28.5164 18.4331 28.2289 18.9588 28.0582C24.7859 26.1984 29 20.7809 29 14.375C29 6.43281 22.5113 0 14.5 0C6.48875 0 0 6.43281 0 14.375C0 15.9652 1.29594 17.25 2.9 17.25C4.50406 17.25 5.8 15.9652 5.8 14.375ZM14.5 46C16.5028 46 18.125 44.3918 18.125 42.4062C18.125 40.4207 16.5028 38.8125 14.5 38.8125C12.4972 38.8125 10.875 40.4207 10.875 42.4062C10.875 44.3918 12.4972 46 14.5 46Z" fill="black"/>
                      </svg> 
                    </div>
                    <span>None of these</span>
                  </div>

                  <div class="profile-arrow">
                    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.71604 11.6564C9.52077 11.8515 9.20421 11.8516 9.00901 11.6564C8.81414 11.4612 8.81405 11.1445 9.00901 10.9494L13.4592 6.49916L1.33323 6.49916L1.23167 6.48939C1.00406 6.44259 0.833231 6.24062 0.833231 5.99916C0.83356 5.75802 1.00429 5.55667 1.23167 5.5099L1.33323 5.49916L13.4592 5.49916L9.00901 1.04994L8.94554 0.970836C8.81778 0.776914 8.83856 0.513646 9.00901 0.342906C9.1798 0.172292 9.44393 0.150538 9.63792 0.278453L9.71604 0.342906L15.0198 5.64564C15.2149 5.84078 15.2146 6.15738 15.0198 6.35267L9.71604 11.6564Z" fill="white"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="invite-footer">
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import API from 'app/axios';

  export default {
    data() {
      return {
        visible: false,
        bClosed: false,
        handle: '',
        profile: {},
        tBounce: false,
        bDelay: false,
        status: '',
        isSearching: false,
        options: {
          invites_s: [],
          invites_p: []
        },
      }
    },

    computed: {
      isVisible() {
        return this.hasApp && this.isGuest && !this.bClosed && this.bDelay && !this.$userEngine.isInviteFlow;
      },
      hasApp() {
        return this.$store.getters.hasApp;
      },
      isGuest() {
        return !this.$store.getters.isLoggedIn;
      },
    },

    mounted() {
      this.fetchOptions();

      window.setTimeout(() => {
        this.bDelay = true;
      }, 1000);

      if (this.isVisible) {
        this.visible = true;
      }

      this.EventBus.$on('modal:nourish-appflow', () => {
        this.track();
        this.visible = true;
      });

      // Inherit all the old requests... 
      this.EventBus.$on('modal:auth', (state = 'sign-up') => {
        // catch/handle sign-in in a new way, or throw the invite screen for signing up..
        if (state == 'sign-in') {
          this.$router.push(`/n/welcome/auth?n=sign-in`);
          return;
        }
        this.track();
        this.visible = true;
      })
    },

    methods: {
      async fetchOptions() {
        const invites = [
          'appstore',
          'playstore'
        ];

        const invitep = [
          'youtube',
          'instagram',
          'linkedin',
          'bluesky',
          'x'
        ];


        // batch fetch (not brill but slightly better than a million requests!)
        API.getThreadsScreenName([...invites,...invitep].join(',')).then(r => {
          Array.from(r).forEach(p => {
            // console.log(p);
            if (invites.includes(p.user)) {
              invites[invites.indexOf(p.user)] = p.profile;
            } else if (invitep.includes(p.user)) {
              invites[invitep.indexOf(p.user)] = p.profile;
            }
          });
          // console.log([invites,invitep]);
        });


        /**
        this.options.invites_s = await Promise.all(
          invites.map(handle => 
            API.getThreadsScreenName(handle).then(r => r.profile)
          )
        );

        this.options.invites_p = await Promise.all(
          invitep.map(handle => 
            API.getThreadsScreenName(handle).then(r => r.profile)
          )
        );
         */
      },

      track() {
        this.EventBus.$emit('track:event', {
          label: 'Nourish: Code',
          once: true,
        });
      },
      login() {
        this.close();
        this.$router.push('/n/welcome?n=sign-in');
      },
      go() {
        this.close();
        this.$userEngine.setOnboardMemo({
          invited_by: this.handle,
        });
        this.$router.push(`/n/welcome?n=invite&from=${this.handle}`);
      },

      close() {
        this.bClosed = true;
        this.visible = false;
      },

      start(social) {
        // track that we clicked it..
        // this.EventBus.$emit('track:event', {
        //   label: 'Invite: Social',
        //   props: {
        //     social: social
        //   }
        // });

        this.close();
        this.$userEngine.setOnboardMemo({
          invited_by: social,
        });
        this.$router.push(`/n/welcome?n=invite&from=${social}`);

        // let url = '';
        // switch (social) {
        //   case 'bluesky':
        //     url = 'https://bsky.app/profile/nourished.news';
        //     break;
        //   case 'linkedin':
        //     url = 'https://www.linkedin.com/company/onesub/';
        //     break;
        //   case 'instagram':
        //     url = 'https://www.instagram.com/nourished.news/';
        //     break;
        // }

        // if (this.hasApp) {
        //     let payload = {
        //     articlePublisher: 'Nourish',
        //     articleURL: url
        //   }

        //   try {
        //     window.webkit.messageHandlers.webviewCallback.postMessage(payload);
        //   } catch(err) { 
        //     console.error(err)
        //   }

        //   try {
        //     if (typeof Android !== 'undefined') {
        //       // eslint-disable-next-line
        //       Android["storyCallback"](JSON.stringify(payload));
        //     }
        //   } catch(err) { 
        //     console.error(err)
        //   }
        // } else {
        //   window.open(url, '_blank');
        // }
      },

      checkHandle() {
        this.tBounce = true;

        // Reset status when we're checking
        this.status = '';

        // min/max
        if ((this.handle.length < 4) || (this.handle.length > 15)) {
          this.profile = {};
          return;
        }

        this.status = 'searching';
        this.profile = {};

        API.getThreadsScreenName(this.handle)
          .then((response) => {
            // cached error?
            if (!response?.profile || response?.profile.error) {
              this.status = 'error';
              this.profile = {};
              return;
            }
            this.profile = response?.profile || {};
            this.status = 'found';
          })
          .catch(() => {
            this.status = 'error';
            this.profile = {};
          });
      }
    },

    watch: {
      handle() {
        if (this.tBounce) window.clearTimeout(this.tBounce);
        this.tBounce = window.setTimeout(this.checkHandle, 600);
      },

      visible(isVisible) {
        if (isVisible) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'unset';
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/v5.scss';

.app-flow {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999999;
  margin: auto;
  display: flex;
  backdrop-filter: brightness(0.5) blur(4px);
  background: rgba(0, 0, 0, 0.75);

  .close {
    position: absolute;
    z-index: 2;
    top: calc(env(safe-area-inset-top) + 1rem);
    right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.8rem;
    height: 2.8rem;
    padding: 0;
    margin-left: auto;
    border-radius: 500px;
    background: rgba($neutral-600, 0.1);

    svg path {
      fill: $neutral-600;
    }

    &.mq-sm {
      top: calc(env(safe-area-inset-top) + 3.5rem);
    }
  }

  .inner {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    max-width: 500px;
    overflow-y: scroll;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
      display: none;
    }
    text-align: center;
    flex: 1;
    height: 80vh;
    padding: calc(3rem + env(safe-area-inset-top, 0em)) 3rem  calc(3rem + env(safe-area-inset-bottom, 0em)) 3rem;
    border-radius: 15px;
    box-shadow: 0px 0px 500px rgba($locales-tone, 0.1);
    background: $neutral-100;
    color: $neutral-600;

    &.mq-sm {
      border-radius: 0;
      height: 100vh;
      padding: calc(4rem + env(safe-area-inset-top, 0rem)) 1.5rem calc(4rem + env(safe-area-inset-bottom, 0em)) 1.5rem;
    }

    .invite-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      // gap: 2.5rem;
      height: 100%;
      z-index: 20;
    }

    .invite-stack {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 1.5rem;
      width: 100%;

      .invite-break {
        text-align: center;
        width: 100%;
        margin-bottom: 0.3rem;

        span {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          width: 100%;

          &::before,
          &::after {
            content: "";
            flex: 1;
            height: 1px;
            background: rgba($neutral-400, 0.25);
          }
        }

        &.spacer {
          margin-bottom: 1rem;
          opacity: 0.5;
          font-size: 0.8rem;
        }
      }
    }

    .invite-footer {
      margin-top: 1rem;
      padding-bottom: 4rem;
    }

    .mark {
      margin-bottom: 0.5rem;
      svg path {
        fill: $neutral-600;
      }
    }

    h2 {
      font-family: 'Brawler';
      font-weight: normal;
      font-size: 40px;
      margin-bottom: 1rem;
      line-height: 110%;
    }

    p {
      text-wrap: balance;
    }

    .ghost {
      margin-top: 1.5rem;
      color: $neutral-400;

      &.login {
        font-weight: normal !important;
        margin-top: 0.5rem;
        font-size: 0.9rem;
        font-weight: bold;
        border-radius: 0;
        padding-bottom: 3px;
        border-bottom: 1px solid rgba($neutral-600, 0.5);
        opacity: 0.7;
        margin-top: 2em;

        &:hover {
          opacity: 1.0;
        }
      }
    }

    input {
      display: flex;
      align-items: center;
      padding: 1.2rem 1.2rem 1rem 1.2rem;
      border-radius: 10px;
      border: none;
      font-size: 16px;
      background: rgba($neutral-600, 0.05);

      &:focus {
        box-shadow: inset 0px 0px 0px 1px $topics-tone;
      }

      &::placeholder {
        color: rgba($neutral-600, 0.6);
      }
    }

    .message {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-bottom: 1.5rem;
      font-size: 0.9rem;
      line-height: 140%;
    }

    .profile-wrapper {
      width: 100%;
    }

    .profile {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 1rem;
      border-radius: 10px;
      font-size: 1rem;
      font-weight: bold;
      margin-bottom: 1rem;
      background: rgba($neutral-600, 0.05);
      cursor: pointer;
      width: 100%;

      &:hover {
        background: rgba($neutral-600, 0.1);
      }

      .content {
        display: flex;
        align-items: center;
        width: 100%;
        
        img {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 2rem;
          height: 2rem;
          border-radius: 500px;
          margin-right: 0.75rem;
        }
      }


      .empty-image {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px dashed rgba($neutral-600, 0.1);
        width: 2rem;
        height: 2rem;
        border-radius: 500px;
        margin-right: 0.75rem;

        svg {
          height: 0.5rem;
          width: 0.95rem;

          path {
            fill: $neutral-600;
          }
        }
      }

      .profile-arrow {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        color: $topics-tone;
        font-weight: bold;
        font-size: 0.8rem;
        
        svg path {
          fill: $topics-tone;
        }
      }
    }
  }
}

.invite-social {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding-bottom: 2rem;

  h4 {
    font-family: 'Circular';
    font-weight: bold;
    font-size: 1rem;
  }
  
  p {
    margin-bottom: 0;
    text-wrap: balance;
  }
  
  .invite-options {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0rem;
    margin-top: 1rem;
    width: 100%;
  }
}

</style>